
export class SchedulerTaskStatus {
  constructor(
    public hash?: string,
    public schedulerTaskHash?: string,
    public status?: number,
    public duration?: number,
    public creationDate?: number
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/scheduler-task-status.ts